

import { Button } from "@a2z/ui";

import { useState } from "react";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import type { SubscriptionPlanView } from "@/lib/api/types";
import type { Locale } from "@/lib/i18n/config";
import { useDialogDismiss } from "@/lib/hooks/useDialogDismiss";
import { StoreSubscriptionForm } from "./StoreSubscriptionForm";

type Props = {
  storeId: string;
  plans: SubscriptionPlanView[];
  locale: Locale;
};

export function StoreSubscriptionModal({
  storeId,
  plans,
  locale,
}: Props) {
  const t = useTranslations();
  const [isOpen, setIsOpen] = useState(false);
  useDialogDismiss(isOpen, () => setIsOpen(false));

  return (
    <>
      <Button
        type="button"
        onClick={() => setIsOpen(true)}
        variant="outline" className="h-9 rounded-lg px-3 text-xs font-semibold text-[color:var(--text-muted)]"
      >
        {t(keys.admin.subscriptionChangeAction)}
      </Button>
      {isOpen ? (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 pt-10 pb-[max(2.5rem,env(safe-area-inset-bottom))]"
          role="dialog"
          aria-modal="true"
          onClick={() => setIsOpen(false)}
        >
          <div
            className="max-h-full w-full max-w-2xl overflow-y-auto rounded-2xl bg-[color:var(--surface)] p-6 shadow-[var(--shadow-md)]"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <h2 className="text-base font-semibold text-[color:var(--text-primary)]">
                  {t(keys.admin.subscriptionChangeTitle)}
                </h2>
                <p className="mt-1 text-xs text-[color:var(--text-muted)]">
                  {t(keys.admin.subscriptionChangeHint)}
                </p>
              </div>
              <Button variant="ghost"
                type="button"
                onClick={() => setIsOpen(false)}
                className="text-xs font-semibold text-[color:var(--text-muted)]"
              >
                {t(keys.common.cancel)}
              </Button>
            </div>
            <div className="mt-5">
              <StoreSubscriptionForm
                storeId={storeId}
                plans={plans}
                locale={locale}
                onSuccess={() => setIsOpen(false)}
              />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
